var render = function render(){var _vm=this,_c=_vm._self._c;return _c('block-content',{attrs:{"blocks":_vm.blocks,"serializers":_vm.serializers,"image-options":{
    containerClass: _vm.containerClass,
    containersAreWide: _vm.containersAreWide
  },"render-container-on-single-child":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }